module.exports = __webpack_public_path__ + "00587615733dd4954be85d8bf79f1d6f.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/apple.svg
// module id = 92v9
// module chunks = 0